import { render } from "./Bitget.vue?vue&type=template&id=7164c5e0&scoped=true"
import script from "./Bitget.vue?vue&type=script&lang=js"
export * from "./Bitget.vue?vue&type=script&lang=js"

import "./Bitget.vue?vue&type=style&index=0&id=7164c5e0&scoped=true&lang=css"

import exportComponent from "C:\\MyTools\\withokx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7164c5e0"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerBox from 'quasar/src/components/spinner/QSpinnerBox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QInput,QBtn,QSpinnerBox,QTooltip,QDialog,QCardSection,QCardActions,QBadge,QToggle,QSpace,QBtnToggle,QSeparator,QScrollArea,QBtnGroup});qInstall(script, 'directives', {ClosePopup});
